// This file is generated by pnpm icons:generate. Do not edit.

import {CircleCheck_Stroke2_Corner0_Rounded as CanonicalCircleCheck_Stroke2_Corner0_Rounded} from './Circle'

/** @deprecated Import CircleCheck_Stroke2_Corner0_Rounded from `#/components/icons/Circle` instead. */
export const CircleCheck_Stroke2_Corner0_Rounded =
  CanonicalCircleCheck_Stroke2_Corner0_Rounded
